import React, { Component } from 'react';
import { Navigation, NavigationPortal } from 'features/Navigation';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import { getMenuItems } from 'features/Navigation/navigationActions';
import { setPreviousPage } from './appActions';
import { AppContainer } from './AppContainer';
import { AppBasePage } from './AppBasePage';
import { ModalPortalDestination } from 'features/Modal';
import { MainContainer } from './MainContainer';
import HamburgareMeny from 'features/HamburgareMeny';
import Login from 'features/Account/Login';
import { ErrorBoundary } from 'features/ErrorBoundary';
import { isEmpty } from '../../utils';
import PageRoutes from '../PageRoutes/PageRoutes';
import { setSelectedFilter } from 'features/CountyFilter';
import { toggleModal } from 'features/CountyFilter/countyFilterActions';
import { resetFilter } from 'features/FilterArea';
import { toggle } from 'features/HamburgareMeny';
import { HamburgareIcon } from 'components/button';
import { validate } from 'features/Account/accountActions';
import { setUpDomEvents } from 'features/DomEvents/domeventsActions';
import { PAGES } from 'constants/pageTypes';
import ModalCountyFilter from 'features/ModalCountyFilter';
import { push } from 'connected-react-router';
import { observeAndHydrateBlocks, hydrateBlocks } from '../../scripts/framework/blockBinder';

class App extends Component {
  constructor(props) {
    super(props);

    const isHybridPage = !!document.querySelector('[data-page-render-mode="contentarea-hybrid"]');

    this.state = {
      currentPageId: undefined,
      isHybridPage
    };
  }
  componentDidMount() {
    const props = this.props;
    const location = props.location || {};
    const currentPage = location.pathname || window.location.pathname;

    props.validate();
    props.setUpDomEvents();
    props.setPreviousPage(currentPage);

    this.stopHydrationObserver = observeAndHydrateBlocks();

    document.documentElement.classList.add('ui-ready');
  }

  componentWillUnmount() {
    if (this.stopHydrationObserver) this.stopHydrationObserver();
  }

  onPageChange = currentPathName => {
    const props = this.props;
    if (currentPathName.length && currentPathName.indexOf('tjanster') === -1) {
      window.scrollTo(0, 0);
    }
    props.setPreviousPage(currentPathName);
    props.resetFilter();
  };

  fetchFooterItems = () => {
    const { selected, getMenuItems } = this.props;
    getMenuItems(selected);
  };

  componentDidUpdate(prevProps) {
    const app = this.props.app;
    const pushRoute = this.props.push;
    const page = this.props.page;
    const nextLocation = this.props.location || {};
    const prevLocation = prevProps.location || {};
    const currentPathName = prevLocation.pathname || '';
    const nextPathname = nextLocation.pathname || '';
    const routes = app.routes || [];
    const currentId = page.currentId;

    if (currentPathName !== nextPathname) {
      this.onPageChange(nextPathname);
      setTimeout(() => hydrateBlocks(document), 0);

      const isHybridPage = !!document.querySelector('[data-page-render-mode="contentarea-hybrid"]');
      if (isHybridPage !== this.state.isHybridPage) this.setState({ isHybridPage });
    }

    if (!routes.length) return;

    const currentRoute = routes.find(function(data) {
      return data.id === currentId;
    });

    if (!currentRoute) return;
    if (currentId === this.state.currentPageId) return;
    if (page.current === null || page.prevPage === null) return;

    pushRoute('' + currentRoute.url[0] + window.location.search);
    this.setState({ currentPageId: currentId });
    this.fetchFooterItems();
  }

  setInitialCategory() {
    const { setSelectedFilter, app, filter } = this.props;
    setSelectedFilter(!isEmpty(app.counties) ? app.counties[0] : filter.categoryList[0]);
  }

  veryClick = expanded => {
    this.props.toggle(!expanded);
    this.props.toggleModal();
  };

  render() {
    const { isLoading: loading } = this.props.app;
    const { burgare, filter, page } = this.props;
    const { selected, isModalOpen } = filter;
    const { expanded } = burgare;
    const is404 = page.current && page.current.pageType === PAGES.NOT_FOUND_PAGE;
    const { isHybridPage } = this.state;
    return (
      <ErrorBoundary>
        <AppContainer>
          <React.Fragment>
            <ModalPortalDestination />
            <Login selectedCounty={selected.id} />
            <NavigationPortal>
              <ModalCountyFilter />
              <Navigation is404={is404} />
              <HamburgareIcon
                onClick={() => this.veryClick(expanded)}
                expanded={expanded}
                hideOnDesktop
                isModalOpen={isModalOpen}
              />
              <HamburgareMeny />
            </NavigationPortal>
            <MainContainer>
              <AppBasePage loading={loading === true ? 'true' : undefined}>
                <Route
                  path="/"
                  render={routeProps => <PageRoutes {...routeProps} isHybridPage={isHybridPage} />}
                />
              </AppBasePage>
            </MainContainer>
          </React.Fragment>
        </AppContainer>
      </ErrorBoundary>
    );
  }
}

const mapStateToProps = function(state) {
  return {
    page: {
      loading: state.page.loading,
      current: state.page.page,
      prevPage: state.page.previousPage,
      currentId: state.page.currentId
    },
    app: {
      routes: state.app.routes,
      sideNav: state.app.sideNav,
      mainNav: state.app.mainNav,
      hamburgerNav: state.app.hamburgerNav,
      footer: state.app.footer,
      counties: state.app.counties,
      pageNotFound: state.app.pageNotFound,
      isLoading: state.app.isLoading,
      settings: state.app.settings,
      previousPage: state.app.previousPage
    },
    filter: {
      counties: state.filter.categoryList,
      selected: state.filter.selected,
      isModalOpen: state.filter.isModalOpen
    },
    burgare: {
      expanded: state.burgare.expanded
    },
    location: state.router.location,
    isSearchActive: state.navigation.isSearchActive
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getMenuItems,
      push,
      setSelectedFilter,
      toggle,
      validate,
      setUpDomEvents,
      resetFilter,
      setPreviousPage,
      toggleModal
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(App);
